import React from "react";
import {Navigate, Route, Routes} from "react-router-dom";
import ChangePassword from "./Components/Login/ChangePassword/ChangePassword";
import {HTMLTitle} from './Components/HTMLTitle/HTMLTitle'
import {LoginFirstPageWrapper} from "./Components/Login/LoginFirstPageWrapper/LoginFirstPageWrapper";
import './App.scss'
import {Home} from "./Components/Home/Home";
import {PublicRoute} from "./Components/Routes/PublicRoute";
import {PrivateRoute} from "./Components/Routes/PrivateRoute";
import {Logout} from "./Components/Logout/Logout";
import {LearningCenter} from "./LearningCenter/LearningCenter";
import {Reports} from "./Components/Reports/Reports";
import {Settings} from "./Components/Settings/Settings";
import {Course} from "./Course/Course";
import {LearningManagement} from "./Components/LearningManagement/LearningManagement";
import {SuperAdminCourseMgmnt} from "./Components/SuperAdmin/SuperAdminCourseMgmnt/SuperAdminCourseMgmnt";
import {SuperAdminCustomerMgmnt} from "./Components/SuperAdmin/SuperAdminCustomerMgmnt/SuperAdminCustomerMgmnt";
import {CourseCompleted} from "./Components/CourseCompleted/CourseCompleted";
import {CompleteCourseForm} from "./Components/CourseCompleted/CompleteCourseForm";
import {SuperAdminAllUsers} from "./Components/SuperAdmin/SAAllItemsPages/SAAllUsers/SAAllUsers";
import {SuperAdminAllOrganizaitons} from "./Components/SuperAdmin/SAAllItemsPages/SAAllOrgs/SAAllOrgs";
import {SignDocPage} from "./Components/SignDocPage/SignDocPage";
import {KnowledgeCenter} from "./Components/KnowledgeCenter/KnowledgeCenter";
import {SuperAdminReports} from "./Components/SuperAdmin/SuperAdminDashboard/SuperAdminReports";
import {SuperAdminPartnerMgmnt} from "./Components/SuperAdmin/SuperAdminPartnerMgmnt/SuperAdminPartnerMgmnt";
import {SuperAdminAssets} from "./Components/SuperAdmin/SuperAdminAssets/SuperAdminAssets";
import {SuperAdminCourseTemplates} from "./Components/SuperAdmin/SuperAdminCourseTemplates/SuperAdminCourseTemplates";
import {QuestionPoolPageWrapped} from "./Components/Questionnaires/QuestionPoolPage/QuestionPoolPage";
import {QuestionnaireSessionPageWrapped} from "./Components/Questionnaires/QuestionnaireSessionPage/QuestionnaireSessionPage";
import {
    AdminCreateLearningPathPage
} from "./Components/LearningPath/AdminCreateLearningPathPage/AdminCreateLearningPathPage";
import LearningPathPage from "./Components/LearningPath/LearnerView/LearningPathPage";
import {WeezBeeCourseEditor} from "./Components/LearningManagement/WeezBeeCourse/WeezBeeCourseEditor";
import {WeezBeeCourseTemplateEditor} from "./Components/LearningManagement/WeezBeeCourse/WeezBeeCourseTemplateEditor";
import {WeezBeeCourseViewer} from "./Components/WeezBeeCourseViewer/WeezBeeCourseViewer";
import {SignDocResultsDetailPage} from "./Components/Reports/SignDocResultsDetailPage/SignDocResultsDetailPage";
import { SignDocListRefresherProvider } from "./contexts/SignDocListRefresherContext";
import {SignDocVersionManagementPage} from "./Components/SignDoc/SignDocVersionManagementPage/SignDocVersionManagementPage";
import {SignDocPreviewPage} from "./Components/SignDoc/SignDocPreviewPage/SignDocPreviewPage";
import {UserSignDocVersionsPage} from "./Components/LearningManagement/UserSignDocVersionsPage/UserSignDocVersionsPage";
// Boaz.ai chat widget - hidden from users while it is not working.
// The component is untouched; uncomment this import and its <N8nChat /> below to bring it back.
// import N8nChat from "./Components/N8nChat/N8nChat";
import {AddToHomeScreenPrompt} from "./Components/Smart/AddToHomeScreenPrompt/AddToHomeScreenPrompt";

class App extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        document.addEventListener("keydown", function (e) {

            if (e.ctrlKey && e.shiftKey && e.code === 'KeyY') {//ctrl+shift+y
                alert(`last updated on: ${process.env.REACT_APP_LAST_UPDATE_DATE}`)
            }
        })
    }


    render() {
        const additionalProps = {
            logout: this.logout,
            ...this.state,
            login: this.login,
        }
        return <>
            <HTMLTitle/>
            {/* Boaz.ai chat widget - hidden from users while it is not working. See the commented import above. */}
            {/* <N8nChat /> */}
            <AddToHomeScreenPrompt />
            <Routes>
                <Route path="/" element={<Navigate to={{pathname: `/login`}} replace={true}/>}/>
                <Route path="/login-password" element={<PublicRoute component={LoginFirstPageWrapper} {...additionalProps}/>}/>
                <Route path="/login" element={<PublicRoute component={({...props}) => <LoginFirstPageWrapper {...props} otpLogin={true} />} {...additionalProps}/>}/>
                <Route path="/changePassword" element={<PublicRoute component={ChangePassword} {...additionalProps}/>}/>
                <Route path="/home" element={<PrivateRoute component={Home} {...additionalProps}/>}/>
                <Route path="/learningCenter/archived/:groupRootId"
                       element={<PrivateRoute component={UserSignDocVersionsPage} {...additionalProps}/>}/>
                <Route path="/learningCenter/*"
                       element={<PrivateRoute component={LearningCenter} {...additionalProps}/>}/>
                <Route path="/knowledgeCenter"
                       element={<PrivateRoute component={KnowledgeCenter} {...additionalProps}/>}/>
                <Route path="/courseComplete/:courseId"
                       element={<PrivateRoute component={CourseCompleted} {...additionalProps}/>}/>
                <Route path="/completeCourseForm/"
                       element={<PrivateRoute component={CompleteCourseForm} {...additionalProps}/>}/>
                <Route path="/course/:signDocId"
                       element={<PrivateRoute context="standAlone" component={Course} {...additionalProps}/>}/>
                <Route path="/signDoc/:signDocId"
                       element={<PrivateRoute component={SignDocPage} {...additionalProps}/>}/>
                <Route path="/questionnaire/:signDocId" element={
                    <PrivateRoute component={QuestionnaireSessionPageWrapped} {...additionalProps}/>
                }/>
                <Route path="/learningManagement/exams/:signDocId/edit" element={
                    <PrivateRoute component={QuestionPoolPageWrapped} {...additionalProps}/>
                }/>
                <Route path="/learningManagement/surveys/:signDocId/edit" element={
                    <PrivateRoute component={QuestionPoolPageWrapped} {...additionalProps}/>
                }/>
                <Route path="/learningManagement/learningPath/:signDocId/edit" element={<PrivateRoute component={AdminCreateLearningPathPage} {...additionalProps}/>}/>
                <Route path="/learningManagement/weezbeeCourse/:signDocId/edit" element={<PrivateRoute component={WeezBeeCourseEditor} {...additionalProps}/>}/>
                <Route path="/learningManagement/signDoc/:signDocId/versions" element={<PrivateRoute component={SignDocVersionManagementPage} {...additionalProps}/>}/>
                <Route path="/admin/signDoc/:signDocId/preview"
                       element={<PrivateRoute component={SignDocPreviewPage} {...additionalProps}/>}/>
                <Route path="/weezbeeCourse/:signDocId"
                       element={<PrivateRoute  component={WeezBeeCourseViewer} {...additionalProps}/>}/>
                <Route path="/learningPathViewer/:signDocId" element={<PrivateRoute component={LearningPathPage} {...additionalProps}/>}/>
                <Route path="/reports/course-results/:signDocId" element={<PrivateRoute component={SignDocResultsDetailPage} {...additionalProps}/>}/>
                <Route path="/nihol/courses"
                       element={<PrivateRoute component={SuperAdminCourseMgmnt} {...additionalProps} context/>}/>
                <Route path="/nihol/customers"
                       element={<PrivateRoute component={SuperAdminCustomerMgmnt} {...additionalProps} context/>}/>
                <Route path="/nihol/partners"
                       element={<PrivateRoute component={SuperAdminPartnerMgmnt} {...additionalProps} context/>}/>
                <Route path="/nihol/users"
                       element={<PrivateRoute component={SuperAdminAllUsers} {...additionalProps} context/>}/>
                <Route path="/nihol/organizations"
                       element={<PrivateRoute component={SuperAdminAllOrganizaitons} {...additionalProps} context/>}/>
                <Route path="/nihol/assets"
                       element={<PrivateRoute component={SuperAdminAssets} {...additionalProps} context/>}/>
                <Route path="/nihol/courseTemplates"
                       element={<PrivateRoute component={SuperAdminCourseTemplates} {...additionalProps} context/>}/>
                <Route path="/nihol/courseTemplateEditor/:templateId/edit"
                       element={<PrivateRoute component={WeezBeeCourseTemplateEditor} {...additionalProps} context/>}/>
                <Route path="/nihol/courseTemplateEditor/new"
                       element={<PrivateRoute component={WeezBeeCourseTemplateEditor} {...additionalProps} context/>}/>
                <Route path="/reports/*" element={<PrivateRoute component={Reports} {...additionalProps}/>}/>
                <Route path="/settings/*" element={<PrivateRoute component={Settings} {...additionalProps}/>}/>
                <Route path="/learningManagement/*"
                       element={<PrivateRoute component={() => <SignDocListRefresherProvider>
                        <LearningManagement />
                        </SignDocListRefresherProvider>} {...additionalProps}/>}/>
                <Route path="/nihol/dashboards/*"
                       element={<PrivateRoute component={SuperAdminReports} {...additionalProps} context/>}/>
                <Route path="/logout" element={<Logout/>}/>
                <Route path="*" element={<Navigate to="/home" replace={true}/>}/>
            </Routes>
        </>
    }

}


export default App
